module.exports = __webpack_public_path__ + "img/train.50f1879f.svg";